<template>
  <div class="embed-responsive" :class="`embed-responsive-${aspectRatio}`">
    <div class="embed-responsive-item">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HMFixedAspectRatioContainer',
  props: {
    aspectRatio: {
      type: String,
      default: '16by9',
    },
  },
};
</script>

<style lang="scss" scoped>
.embed-responsive-item > * {
  width: 100%;
  height: 100%;
}
.embed-responsive-item > img {
  object-fit: cover;
}
</style>
